import { render } from "./BlockDetailedView.vue?vue&type=template&id=4a3b14e5&scoped=true"
import script from "./BlockDetailedView.vue?vue&type=script&lang=js"
export * from "./BlockDetailedView.vue?vue&type=script&lang=js"

import "./BlockDetailedView.vue?vue&type=style&index=0&id=4a3b14e5&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3b14e5"]])

export default __exports__